import { withRouter } from 'react-router-dom';
import { useEffect } from 'react';
import * as routes from 'constants/routes';

const ScrollToTop = ({ children, location: { pathname, search } }) => {
    useEffect(() => {
        const isExpertsWithId = pathname === routes.experts && new URLSearchParams(search).get('id');
        if (isExpertsWithId) return;

        window.scrollTo(0, 0);
    }, [pathname, search]);

    return children || null;
};

export default withRouter(ScrollToTop);